import {TableConfig} from '@shared/interfaces/table/table-config';
import {ConnectionPointHistoricalDto} from '@app/api/nts';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {statePartial} from '@shared/partials/state.partial';
import {DATE_TIME_FORMAT} from '@app/core/constants/date-time-format';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const connectionpointHistoryTable: TableConfig<ConnectionPointHistoricalDto> = {
  selectable: true,
  columns: [
    {
      title: 'connectionpoint.history.index',
      key: 'index'
    },
    {
      title: 'connectionpoint.history.date',
      key: 'date',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    {
      title: 'connectionpoint.history.action',
      key: 'action',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        remove: 'historicalAction.remove',
        update: 'historicalAction.update',
        create: 'historicalAction.create',
        disconnect: 'historicalAction.disconnect',
        connect: 'historicalAction.connect',
        notspecified: 'historicalAction.notSpecified',
      }
    },
    {
      title: 'connectionpoint.identification',
      key: 'identification'
    },
    statePartial,
    {
      title: 'connectionpoint.history.user',
      key: 'changeBy'
    }
  ]
}
